export default "__VITE_ASSET__ycGCrs_d__"